"use strict";

module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) > -1;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/is-date-filter.js
// module id = 1631
// module chunks = 61